import { Node, mergeAttributes } from '@tiptap/core';

const DropdownItemTitleName = "dropdownItemTitle";
const DropdownItemTitle = Node.create({
  name: DropdownItemTitleName,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "dropdownItem",
  content: "(paragraph | heading)",
  defining: true,
  parseHTML() {
    return [
      {
        tag: `div[data-node-type="${DropdownItemTitleName}"]`
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        ["data-node-type"]: DropdownItemTitleName
      }),
      0
    ];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const isActive = editor.isActive(this.name);
        const { $from, from, to } = editor.state.selection;
        if (isActive && $from.start() === from && to === from) {
          return editor.commands.liftDropdownItem();
        }
        return false;
      },
      Enter: ({ editor }) => {
        const isActive = editor.isActive(this.name);
        if (isActive) {
          return editor.commands.splitDropdownItem();
        }
        return false;
      }
    };
  }
});

export { DropdownItemTitle, DropdownItemTitleName };
//# sourceMappingURL=DropdownItemTitle.js.map
